import React, { useEffect, useState } from 'react'
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import HttpClient from '../../../utils/HttpClient'
import { useUserData } from '../../../Providers/UserWrapper'
import toast from 'react-hot-toast'
import DeleteModal from '../../../Modal/deleteMoal/DeleteModal'
import ViewCapitalOptComp from './ViewCapitalOptComp'
import { useLanguage } from '../../../Providers/LanguageContext'
import { useLocation, useNavigate } from 'react-router-dom'

const ViewCapitalOption = () => {
    const { setIsLoading } = useUserData();
    const { language, currentLanguage } = useLanguage()
    const [debtData, setDebtData] = useState([])
    const [equityData, setEquityData] = useState([])
    const navigate = useNavigate();
    // getCapitalData
    const getCapitalData = async () => {
        setIsLoading(true)
        const res = await HttpClient.requestData("get-investment-capital-by-user", "GET", {})
        console.log("resdsd", res)
        setIsLoading(false)
        if (res && res?.status) {
            const debt = res?.data?.filter(item => item?.raiseCapitalType === "Debt Capital Raise"
                || item?.raiseCapitalType === "Debt"
            )
            const equity = res?.data?.filter(item => item?.raiseCapitalType === "Equity Capital Raise")
            setDebtData(debt)
            setEquityData(equity)
        }
    }

    // accept
    const handleAccept = async (item) => {
        const data = {
            "acceptStatus": "accepted", // ['accepted', 'cancelled']
            "language": currentLanguage === "eng" ? "EN" : "ES"
        }
        setIsLoading(true)
        const res = await HttpClient.requestData("update-accept-status-by-user/" + item?._id, "PUT", data)
        setIsLoading(false)
        if (res && res?.status) {
            toast.success("Investment Accepted SuccessFully");
            getCapitalData();
        } else {
            toast.error(res?.messeage || "Error")
        }
    }

    // reject
    const handleReject = async (item) => {

        const data = {
            "acceptStatus": "cancelled" // ['accepted', 'cancelled']
        }

        setIsLoading(true)
        const res = await HttpClient.requestData("update-accept-status-by-user/" + item?._id, "PUT", data)
        setIsLoading(false)
        if (res && res?.status) {
            toast.success("Investment Rejected SuccessFully")
            getCapitalData()
        } else {
            toast.error(res?.messeage || "Error")
        }
    }

    useEffect(() => {
        getCapitalData()
    }, [])
    useEffect(() => {
        window.scrollTo({ top: '0', behavior: 'instant' })
    }, []);
    const location = useLocation();

    return (
        <>
            {/* <div className="try_fisibilty_wrapper " style={{
                transform: 'translateY(0%)',
                margin: '0px',
                justifyContent: 'start',
                background: '#031f31ff'

            }}>
                <div className="container-fluid">
                    <p className="text-left">Investment Manager / Capital Options</p></div>
            </div> */}
            <section className="bookkeperSection captial_optionSection pt-3" style={{
                background: 'linear-gradient(rgba(15, 36, 55, 1), rgb(255, 255, 255))',
                paddingTop: '30px'
            }}>

                {
                    location?.pathname !== "/favourite-dashboard" && (
                        <div className="container-fluid" >
                            <div className="task_head">Investment Manager – Capital Options</div>
                        </div>
                    )
                }
                {
                    location?.pathname !== "/favourite-dashboard" && (
                        <div className='d-flex  gap-2 navigation_buttons_wrapper container-fluid mt-3 mb-3'>

                            <button className='slctUser' style={{
                                background: 'rgb(136, 233, 132)',
                                fontWeight: '500',
                                color: '#0c2637'
                            }}
                                onClick={() => navigate('/raise-capital')}>{language.raise_capital}</button>



                            <button className='slctUser' style={{
                                background: 'rgb(136, 233, 132)',
                                fontWeight: '500',
                                color: '#0c2637'
                            }}
                                onClick={() => navigate('/view-investor-document')}>
                                {language.view_upload_docs}
                            </button>

                        </div>
                    )
                }
                <div className="container-fluid mt-3" style={{
                    border: '4px solid #fff',
                    borderRadius: '25px',
                    padding: '40px 20px'
                }}>

                    <Tabs className="bookeperPlanTab" >
                        <TabList>
                            <Tab >
                                <div className="bookkeTabDiv">
                                    <label className="bookkPlan">Debt Capital Raise</label>
                                </div>
                            </Tab>
                            <Tab>
                                <div className="bookkeTabDiv">
                                    <label className="bookkPlan">Equity Capital Raise</label>
                                </div>
                            </Tab>
                        </TabList>


                        {/* Debt Capital Raise */}
                        <TabPanel>
                            <ViewCapitalOptComp

                                arrData={debtData}
                                handleAccept={handleAccept}
                                handleReject={handleReject}
                            />
                        </TabPanel>


                        {/* Equity Capital Raise */}
                        <TabPanel>
                            <ViewCapitalOptComp
                                arrData={equityData}
                                handleAccept={handleAccept}
                                handleReject={handleReject}
                            />

                        </TabPanel>

                    </Tabs>

                </div>
            </section>

            {/* {
                isAccepet &&
                <DeleteModal

                />
            }


            {
                isReject &&
                <DeleteModal
                    closeDeleteModal={() => setIsReject(false)}
                    handleDelete={handleReject}
                />
            } */}

        </>
    )
}

export default ViewCapitalOption
